//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';
import { jsonParse } from 'src_common/common/jsonParse';



export interface ParamsType {
    bonusId: number,
}


const Response200IO = t.interface({
    id: t.number,
});

export type Response200Type = {
    id: number,
};

export const decodeResponse200 = (data: unknown): Response200Type => {
    const decodeResult = Response200IO.decode(data);
    if (isRight(decodeResult)) {
        return decodeResult.right;
    }
    throw Error('Response decoding error /bonuses-ep/bonus-configuration/{bonusId} -> delete -> 200');
};






export const openapi_bonuses_deleteBonuses = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType): Promise<FetchGeneralRawResponseType> => {
    const url = `${api_url}/bonuses-ep/bonus-configuration/${params.bonusId}`;
    const method = 'DELETE';
    const paramsFetch = {
        url,
        body: undefined,
        backendToken,
        timeout: api_timeout,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};


export type OpenapiBonusesDeleteBonusesParamsType = ParamsType;

export type OpenapiBonusesDeleteBonusesResponseType = {
    status: 200,
    body: Response200Type,
};

export type OpenapiBonusesDeleteBonusesResponse200Type = Response200Type;

export const openapiBonusesDeleteBonusesRequest = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType): Promise<OpenapiBonusesDeleteBonusesResponseType> => {
    const response = await openapi_bonuses_deleteBonuses(api_url, api_timeout, backendToken, params);
    const { status, body } = response;
    const bodyParsed = jsonParse(body);

    if (bodyParsed.type === 'text') {
        throw Error(`Http status ${status} - json was expected`);
    }

    
    if (status === 200) {
        return {
            status: 200,
            body: decodeResponse200(bodyParsed.json)
        };
    }

    throw new Error(`openapiBonusesDeleteBonusesRequest - unhandled response ${response.status}`);
};

